import React from 'react';

import 'ui-kit/icons/social-media-icons/social-media-icon.style.css';

const Instagram = ({ variant }) => {
    const getVariantStyle = () => {
        switch (variant) {
            case 'light': {
                return { fill: 'rgb(255,255,255)', height: '25', width: '25' };
            }
            case 'primary': {
                return { fill: 'rgb(3,164,220)', height: '25', width: '25' };
            }
            default: {
                return { fill: 'rgb(3,164,220)', height: '100%', width: '100%' };
            }
        }
    };

    const variantStyle = getVariantStyle();

    return (
        <svg
            className="social-media-icon instagram"
            xmlns="http://www.w3.org/2000/svg"
            width={variantStyle.width}
            height={variantStyle.height}
            viewBox="0 0 25 25"
        >
            <g transform="translate(36 0)">
                <path
                    fill={variantStyle.fill}
                    fillRule="evenodd"
                    d="M-29.5605392 25h12.64739323c3.40569115 0 6.17630386-2.77061272 6.17630386-6.17630386V6.1763029C-10.7368421 2.77070594-13.50745482 0-16.91314597 0H-29.5605392c-3.40559697 0-6.1763029 2.77070594-6.1763029 6.17630291v12.64739323C-35.7368421 22.22938728-32.96613618 25-29.5605392 25zm-4.31526994-18.82369709c0-2.37942362 1.93584633-4.31526995 4.31526994-4.31526995h12.64739323c2.37942314 0 4.31527138 1.93584633 4.31527138 4.31526995v12.64739323c0 2.37942314-1.93584824 4.31527137-4.31527138 4.31527137H-29.5605392c-2.37942361 0-4.31526994-1.93584823-4.31526994-4.31527137V6.1763029z"
                />
                <path
                    fill={variantStyle.fill}
                    fillRule="evenodd"
                    d="M-30.18128676 12.49995232c0 3.82919502 3.11522198 6.94449234 6.94444465 6.94449234 3.82922364 0 6.94444466-3.11529732 6.94444466-6.94449234 0-3.82910061-3.11522102-6.94439698-6.94444466-6.94439698-3.82922267 0-6.94444465 3.11529637-6.94444465 6.94439698zm1.92013216 0c0-2.7703476 2.25385046-5.02427817 5.0243125-5.02427817 2.77036666 0 5.02431297 2.25393057 5.02431297 5.02427817 0 2.77044296-2.2539463 5.024374-5.02431298 5.024374-2.77046203 0-5.0243125-2.25393104-5.0243125-5.024374z"
                />
                <path
                    fill={variantStyle.fill}
                    fillRule="evenodd"
                    d="M-17.68128655 5.05952381c0-.493108.39973152-.89285714.89289653-.89285714.49308624 0 .89281776.39974915.89281776.89285714 0 .49310799-.39973152.89285714-.89281776.89285714-.49316501 0-.89289653-.39974915-.89289653-.89285714"
                />
            </g>
        </svg>
    );
};

export default Instagram;
